// AGC: Mock data for fields and plots
import { Field, Plot } from '../types'

/**
 * AGC: Mock plots data
 */
export const mockPlots: Plot[] = [
  {
    id: 'plot-1',
    fieldId: 'field-1',
    name: 'Talhão Norte A',
    area: 45.5,
    perimeter: 2850,
    cropType: 'soja',
    variety: 'Intacta RR2 PRO',
    plantingDate: '2024-09-15',
    expectedHarvestDate: '2025-02-20',
    growthStage: 'vegetativo',
    healthStatus: 'bom',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 45,
    coordinates: [
      [-15.7801, -47.9292],
      [-15.7805, -47.9250],
      [-15.7850, -47.9255],
      [-15.7845, -47.9295],
    ],
    soilType: 'argiloso',
    irrigated: true,
    yieldEstimate: 3800,
    notes: 'Aplicação de fungicida programada para próxima semana',
    createdAt: '2024-09-01',
    updatedAt: '2024-11-28',
  },
  {
    id: 'plot-2',
    fieldId: 'field-1',
    name: 'Talhão Norte B',
    area: 38.2,
    perimeter: 2480,
    cropType: 'milho',
    variety: 'Pioneer P30F53',
    plantingDate: '2024-10-01',
    expectedHarvestDate: '2025-03-15',
    growthStage: 'floracao',
    healthStatus: 'excelente',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 60,
    coordinates: [
      [-15.7810, -47.9200],
      [-15.7815, -47.9160],
      [-15.7855, -47.9165],
      [-15.7850, -47.9205],
    ],
    soilType: 'franco',
    irrigated: true,
    yieldEstimate: 12000,
    createdAt: '2024-09-01',
    updatedAt: '2024-11-25',
  },
  {
    id: 'plot-3',
    fieldId: 'field-1',
    name: 'Talhão Sul',
    area: 52.8,
    perimeter: 2920,
    cropType: 'soja',
    variety: 'TMG 2183 IPRO',
    plantingDate: '2024-09-20',
    expectedHarvestDate: '2025-02-25',
    growthStage: 'vegetativo',
    healthStatus: 'regular',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 35,
    coordinates: [
      [-15.7900, -47.9290],
      [-15.7905, -47.9240],
      [-15.7960, -47.9245],
      [-15.7955, -47.9295],
    ],
    soilType: 'argiloso',
    irrigated: false,
    yieldEstimate: 3200,
    notes: 'Déficit hídrico detectado - monitorar irrigação',
    createdAt: '2024-09-05',
    updatedAt: '2024-11-30',
  },
  {
    id: 'plot-4',
    fieldId: 'field-2',
    name: 'Área Leste 1',
    area: 28.5,
    perimeter: 2140,
    cropType: 'trigo',
    variety: 'BRS 264',
    plantingDate: '2024-05-10',
    expectedHarvestDate: '2024-09-20',
    growthStage: 'colheita',
    healthStatus: 'bom',
    managementStatus: 'pronto-colher',
    managementProgress: 95,
    coordinates: [
      [-15.7700, -47.9100],
      [-15.7705, -47.9060],
      [-15.7740, -47.9065],
      [-15.7735, -47.9105],
    ],
    soilType: 'franco',
    irrigated: true,
    yieldEstimate: 4500,
    createdAt: '2024-04-20',
    updatedAt: '2024-09-18',
  },
  {
    id: 'plot-5',
    fieldId: 'field-2',
    name: 'Área Leste 2',
    area: 35.0,
    perimeter: 2370,
    cropType: 'milho',
    variety: 'AG 1051',
    plantingDate: '2024-10-15',
    expectedHarvestDate: '2025-03-30',
    growthStage: 'germinacao',
    healthStatus: 'excelente',
    managementStatus: 'semeado',
    managementProgress: 15,
    coordinates: [
      [-15.7710, -47.9050],
      [-15.7715, -47.9010],
      [-15.7755, -47.9015],
      [-15.7750, -47.9055],
    ],
    soilType: 'arenoso',
    irrigated: true,
    yieldEstimate: 10500,
    createdAt: '2024-10-10',
    updatedAt: '2024-11-28',
  },
  {
    id: 'plot-6',
    fieldId: 'field-3',
    name: 'Pivô Central',
    area: 120.0,
    perimeter: 4380,
    cropType: 'soja',
    variety: 'Brasmax Desafio',
    plantingDate: '2024-09-25',
    expectedHarvestDate: '2025-03-01',
    growthStage: 'vegetativo',
    healthStatus: 'bom',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 50,
    coordinates: [
      [-15.8000, -47.9400],
      [-15.8010, -47.9300],
      [-15.8100, -47.9310],
      [-15.8090, -47.9410],
    ],
    soilType: 'argiloso',
    irrigated: true,
    yieldEstimate: 4200,
    createdAt: '2024-09-10',
    updatedAt: '2024-11-29',
  },
  {
    id: 'plot-7',
    fieldId: 'field-3',
    name: 'Sequeiro Norte',
    area: 85.5,
    perimeter: 3700,
    cropType: 'milho',
    variety: 'DKB 390 PRO3',
    plantingDate: '2024-10-05',
    expectedHarvestDate: '2025-03-20',
    growthStage: 'vegetativo',
    healthStatus: 'regular',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 40,
    coordinates: [
      [-15.7950, -47.9450],
      [-15.7960, -47.9380],
      [-15.8020, -47.9390],
      [-15.8010, -47.9460],
    ],
    soilType: 'franco',
    irrigated: false,
    yieldEstimate: 8500,
    notes: 'Aguardando chuvas para próxima aplicação',
    createdAt: '2024-09-28',
    updatedAt: '2024-11-27',
  },
  {
    id: 'plot-8',
    fieldId: 'field-4',
    name: 'Experimental 1',
    area: 15.0,
    perimeter: 1550,
    cropType: 'cafe',
    variety: 'Catuaí Vermelho',
    plantingDate: '2022-03-15',
    expectedHarvestDate: '2025-06-01',
    growthStage: 'frutificacao',
    healthStatus: 'excelente',
    managementStatus: 'em-desenvolvimento',
    managementProgress: 70,
    coordinates: [
      [-15.7600, -47.9000],
      [-15.7605, -47.8980],
      [-15.7625, -47.8985],
      [-15.7620, -47.9005],
    ],
    soilType: 'argiloso',
    irrigated: true,
    yieldEstimate: 2500,
    createdAt: '2022-03-01',
    updatedAt: '2024-11-20',
  },
]

/**
 * AGC: Mock fields data
 */
export const mockFields: Field[] = [
  {
    id: 'field-1',
    name: 'Fazenda Santa Maria',
    location: 'Cristalina, GO',
    totalArea: 136.5,
    plots: mockPlots.filter(p => p.fieldId === 'field-1'),
    coordinates: [-15.7850, -47.9270],
    createdAt: '2024-01-15',
    updatedAt: '2024-11-30',
  },
  {
    id: 'field-2',
    name: 'Sítio Água Limpa',
    location: 'Luziânia, GO',
    totalArea: 63.5,
    plots: mockPlots.filter(p => p.fieldId === 'field-2'),
    coordinates: [-15.7720, -47.9080],
    createdAt: '2024-02-20',
    updatedAt: '2024-11-28',
  },
  {
    id: 'field-3',
    name: 'Fazenda Boa Vista',
    location: 'Formosa, GO',
    totalArea: 205.5,
    plots: mockPlots.filter(p => p.fieldId === 'field-3'),
    coordinates: [-15.8000, -47.9400],
    createdAt: '2024-03-10',
    updatedAt: '2024-11-29',
  },
  {
    id: 'field-4',
    name: 'Área Experimental',
    location: 'Planaltina, DF',
    totalArea: 15.0,
    plots: mockPlots.filter(p => p.fieldId === 'field-4'),
    coordinates: [-15.7610, -47.8990],
    createdAt: '2022-01-05',
    updatedAt: '2024-11-20',
  },
]

/**
 * AGC: Get field by ID
 */
export const getFieldById = (id: string): Field | undefined => {
  return mockFields.find(field => field.id === id)
}

/**
 * AGC: Get plot by ID
 */
export const getPlotById = (id: string): Plot | undefined => {
  return mockPlots.find(plot => plot.id === id)
}

/**
 * AGC: Get plots by field ID
 */
export const getPlotsByFieldId = (fieldId: string): Plot[] => {
  return mockPlots.filter(plot => plot.fieldId === fieldId)
}







